import email from '../assets/email.png';
import mobile from '../assets/mobile.png';

import node from '../assets/node.png';


import circle from '../assets/circle.svg';
import logo from '../assets/taimoor-logo-black.png';

import rn from '../assets/react native_icon.png';
import nodejs from '../assets/_nodejs_icon.png';
import devops from '../assets/Devops.png';


export default {
  email,
  mobile,
  node,
  circle,
  logo,
  rn,
  nodejs,
  devops,
 

};
